import styled from 'styled-components'

export const StyledLi = styled.li`
  counter-increment: customlistcounter;
  position: relative;
  display: flex;
  text-align: left;
  font-size: 25px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
  margin-bottom: 4rem;
  @media only screen and (max-width: 650px) {
    font-size: 21px;
  }
  &:before {
    height: 50px;
    width: 50px;
    display: flex;
    justify-content: center;
    color: white;
    position: absolute;
    align-items: center;
    font-size: 23px;
    background-color: ${({ theme, liColor }) =>
      liColor || theme.colors.buttonDefault};
    border-radius: 50%;
    content: counter(customlistcounter) '';
    margin-right: 34px;
    @media only screen and (max-width: 650px) {
      font-size: 19px;
    }
  }
`

export const Word = styled.span`
  display: inline-block;
  color: ${({ liColor }) => liColor};
  font-size: 27px;
  margin-right: 7px;
  font-weight: 600;
`

export const Paragraph = styled.p`
  max-width: 1300px;
  margin-left: 84px;
  padding-top: 4px;
  display: inline-block;
  color: ${({ inverse, theme }) => (inverse ? `white` : theme.colors.grey1)};
  font-weight: 400;
  font-size: ${({ inverse }) => (inverse ? `25px` : `23px`)};
  @media only screen and (max-width: 650px) {
    font-size: 19px;
  }
`
